import { createRequest } from '@savgroup-front-common/core/src/services/request';

export const LOAD_SELLERS_INFO = createRequest(
  'SELLERS_INFO/LOAD_SELLERS_INFO',
);
